<template>
  <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">

    <vs-prompt title="Edit Bank Account" accept-text="Edit" @cancel="clearValMultiple" @accept="acceptAlert"
      @close="close" :active.sync="activePrompt">
      <div class="con-exemple-prompt">

        <vs-input placeholder="Account Owner" label="Account Owner" v-model="bank.accountOwner" class=" mb-2 w-full" />

        <v-select data-vv-validate-on="blur" placeholder="Choose your bank" name="name"
                    v-model="selectedBank" v-validate="'required'" class="w-full mt-4 mb-2" label="name"
                    :options="bankNames" @input="setSwift" />

<label class="mt-4 vs-input--label"> Currency</label>
                    <v-select data-vv-validate-on="blur" placeholder="Choose your currency" name="currency"
                    v-model="selectedCurrency" v-validate="'required'" class="w-full  mb-2" label="code"
                    :options="currencyOptions" />

        <vs-input placeholder="IBAN Number" label="IBAN" v-model="bank.iban" class="mt-4 mb-2 w-full" />
        <vs-input placeholder="Swift Code" label="Swift" v-model="bank.swift" :disabled="true" class="mt-4 mb-2 w-full" />








        <div class="mt-4 mb-2">
          <label class="vs-input--label"> Account type</label>
          <v-select data-vv-validate-on="blur" placeholder="Select type of account" name="platform_name"
            v-model="bank.type" v-validate="'required'" class="w-full" label="typeName" :options="bankTypeOptions"
            :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        </div>









        <vs-input placeholder="Client ID" label="Client ID" v-if="bank.type && bank.type.typeCode == 1"
          v-model="bank.shopCode" class="mt-4 mb-2 w-full" />
        <vs-input placeholder="Store Key" label="Store Key" v-if="bank.type && bank.type.typeCode == 1"
          v-model="bank.storeKey" class="mt-4 mb-2 w-full" />

        <div class="mt-4 mb-2">
          <label class="vs-input--label"> Account Status</label>
          <vs-switch v-model="bank.status" />
        </div>

      </div>
    </vs-prompt>


    <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord" />

    <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
      @click="confirmDeleteRecord" />



  </div>
</template>

<script>
  import vSelect from 'vue-select'

  export default {
    name: 'CellRendererActions',
    components: {
      'v-select': vSelect,
    },
    created(){
      this.getCurrencies();
    },
    // computed: {
    //   currencyOptions() {
                
    //             return this.$store.getters['product/allCurrencies']
    //         },
    // },
    data() {
      return {
        currencyOptions:[],
        temp:'',
        bankTypeOptions: [{
            typeName: 'Credit card',
            typeCode: '1'
          },
          {
            typeName: 'Bank trnsfer',
            typeCode: '2'
          }
        ],
        selectedBank:[{id:''}],
        selectedCurrency:'',
        bankNames:[],
        activePrompt: false,
        bank: {
          name: '',
          accountOwner:'',
          iban: '',
          swift: '',
          id: '',
          type: {
            typeCode: null
          },
          status: false,
          shopCode: '',
          storeKey: '',
          currency:''
        }
      }
    },
    
    methods: {
       getCurrencies(){



                this.selectedCurrency = this.currencyOptions.filter(x=> x.code == this.params.data.currency)[0]


                 this.$store.dispatch('product/getCurrencies')
                 .then((response) => {
                       this.currencyOptions = response.data
                       this.selectedCurrency = response.data.filter(x=> x.code == this.params.data.currency)[0]
                    })
                    .catch(error => {
                        this.$vs.loading.close()
                        this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    })
            },
      setSwift(){
                this.selectedBank != null && this.selectedBank.swiftCode ? this.bank.swift =  this.selectedBank.swiftCode : this.bank.swift = ''
               
            },
      acceptAlert() {
        // this.$vs.loading()
        const payload = {}
        payload["AccountType"] = 2
        payload["accountOwner"] = this.bank.accountOwner
        payload["Id"] = this.selectedBank.id
        payload["SwiftCode"] = this.bank.swift
        payload["ibanNo"] = this.bank.iban
        payload["BankName"] = this.bank.name
        payload["currencyId"] = this.selectedCurrency.id
        payload["AccountType"] = this.bank.type.typeCode
        payload["IsActive"] = this.bank.status
        payload["shopCode"] = this.bank.shopCode
        payload["storeKey"] = this.bank.storeKey
        this.$store.dispatch('bank/editAccount', payload)
          .then((response) => {
            this.$vs.loading.close()
            this.$store.dispatch('bank/getAllAccounts')
            this.$vs.notify({
              color: 'success',
              title: 'Acccount Edited',
              text: response.data.message
            })
          })
          .catch(error => {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Error',
              text: error.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          })


      },
      close() {
        return true
      },
      clearValMultiple() {
        this.bank.name = "";
        this.bank.iban = "";
        this.bank.swift = "";
        this.bank.type = null;
      },

      editRecord() {



        this.$store.dispatch('bank/getBanks')
                    .then((response) => {
                        this.$vs.loading.close()
                        this.bankNames = response.data




        this.activePrompt = true;
        this.bank.accountOwner = this.params.data.accountOwner;
        this.bank.name = this.params.data.bankName;
        this.bank.iban = this.params.data.ibanNo;
        this.bank.swift = this.params.data.bank.swiftCode;
        this.bank.id = this.params.data.id;
        this.bank.status = this.params.data.isActive;
        this.bank.shopCode = this.params.data.shopCode;
        this.bank.storeKey = this.params.data.storeKey;
        this.bank.type = this.bankTypeOptions.filter(obj => obj.typeCode == this.params.data.accountType)[0]

        let temp = this.bankNames.filter(obj => {
          return obj.id == this.params.data.bankId
        })
        this.selectedBank = temp[0]
        this.selectedBank.id = this.params.data.id




                    })
                    .catch(error => {
                        this.$vs.loading.close()
                        this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    })





      
      },

      confirmDeleteRecord() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Confirm Delete',
          text: `You are about to delete "${this.params.data.bank.name}"`,
          accept: this.deleteRecord,
          acceptText: 'Delete'
        })
      },
      deleteRecord() {
        /* UnComment below lines for enabling true flow if deleting user */
        this.$store.dispatch("bank/deleteAccount", this.params.data.id)
          .then((response) => {
            this.$store.dispatch('bank/getAllAccounts')
            his.showDeleteSuccess(response.data)
          })
          .catch(err => {
            console.warn(err)
          })

      },





    }
  }
</script>